// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nm-0";